var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0D47A1",
    points: "11.536 21.231 14.305 24 21.695 24 15.232 17.537 11.536 21.231"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#42A5F5",
    points: "7.849 17.538 11.539 13.848 15.229 17.538 11.539 21.229 7.849 17.538"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5A9FD7",
    points: "15.233 17.536 15.231 17.536 15.231 17.536 15.232 17.536 15.232 17.536 15.233 17.536"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0B3E8C",
    points: "15.372 17.677 17.02 19.337 13.11 20.688 12.054 21.744 11.54 21.23 11.536 21.231 14.305 24 21.695 24 15.372 17.677"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3990D5",
    points: "15.227 17.536 7.852 17.536 7.849 17.538 11.539 21.229 15.229 17.538 15.227 17.536"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "a",
    points: "13.11 20.688 11.54 21.23 12.054 21.744 13.11 20.688"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M11.539,21.229l-0.003,0.003L11.539,21.229 M15.232,17.536L15.232,17.536l0.14,0.141L15.232,17.536 M15.231,17.536l-3.692,3.692l3.69-3.69l0,0L15.231,17.536L15.231,17.536"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "c",
    points: "15.232 17.536 15.231 17.536 15.232 17.537 15.232 17.536 15.232 17.536"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M11.539,21.229l-0.003,0.003l0.004-0.001L11.539,21.229 M15.232,17.537L15.232,17.537l-0.002,0.002l0.515,0.515l-2.634,2.634l3.91-1.35l-1.648-1.661L15.232,17.537"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "e",
    points: "15.229 17.538 11.539 21.229 15.229 17.539 15.229 17.538"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "f",
    points: "15.229 17.539 11.539 21.229 11.54 21.23 13.11 20.688 15.744 18.054 15.229 17.539"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68B7F7",
    d: "M21.695,11.073h-7.391l-2.768,2.768l3.694,3.694h0.002L21.695,11.073L21.695,11.073z M21.695,0h-7.391l-12,11.999L6,15.695L21.695,0L21.695,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B9FD7",
    d: "M20.844,11.073h-6.539l-2.768,2.768l3.694,3.694h0.002l5.611-5.611V11.073L20.844,11.073z M15.695,6H8.304l-5.999,5.999L6,15.695L15.695,6L15.695,6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterIcon);
export default __webpack_public_path__ + "static/media/flutter-icon.4afb84e352a08244184de077ec58cd7a.svg";
export { ForwardRef as ReactComponent };